import Formatter from "@/prototype/src/formatter";

export default {
    install(Vue, option) {
        Vue.prototype.$formatter = new (function () {
            this.pad = Formatter.pad;
            this.separator = Formatter.separator;
            this.roundUp = Formatter.roundUp;
            this.round = Formatter.round;
            this.formatMoney = Formatter.formatMoney;
            this.formatDate = Formatter.formatDate;
            this.getDay = Formatter.getDay;
            this.convertDate = Formatter.convertDate;
            this.sortDate = Formatter.sortDate;

            this.generateId = (id) => {
                return `#${Formatter.pad(id, 5)}`;
            }

            this.generateCourseTitle = (course, gradeOptions = []) => {
                const foundGrade = gradeOptions.find(el => el.value === course.grade);
                let text = '';
                if (foundGrade) {
                  if(foundGrade.text != ''){
                    text += foundGrade.text + ' ';
                  }
                } else {
                  if(course.grade != ''){
                    text += course.grade + ' ';
                  }
                }
                if (course.category_data) {
                    text += course.category_data.name;
                }
                return text;
            }

            /**
            * 
            * @param {String} e - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Number - DD
            */
            this.dayFormat = (e) => {
                return parseInt(e.substring(8, 10), 10).toString()
            }

            // ----- Keydown Events
            this.number = event => {
                // [0-9]
                if (event.charCode >= 48 && event.charCode <= 57) {
                    return true
                }

                return event.preventDefault()
            }

            this.floating = event => {
                // [0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46) {
                    return true
                }

                return event.preventDefault()
            }

            this.numberWithNegative = event => {
                // [-][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.floatingWithNegative = event => {
                // [-][0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46 || event
                    .charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.alphaNumeric = event => {
                // [0-9A-Za-z]
                if (
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122)
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.phone = event => {
                // +[0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 43) {
                    return true
                }

                return event.preventDefault()
            }

            this.engName = event => {
                // [a-zA-Z\s.,]
                if (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    event.charCode === 32 || event.charCode === 46 || event.charCode === 188
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.id = event => {
                // #[0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 35) {
                    return true
                }

                return event.preventDefault()
            }

            this.time = event => {
                // [0-9][:][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 58) {
                    return true
                }

                return event.preventDefault()
            }
            this.date = event => {
                // [0-9][-][0-9][-][0-9]
                // [0-9][/][0-9][/][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45 || event.charCode === 47) {
                    return true
                }

                return event.preventDefault()
            }
        })()
    }
}